import _ from "lodash";
import React from "react";
import { useSelector } from "react-redux";
import { Grid, Header, Segment, List } from "semantic-ui-react";
import { KevelButtons } from "../utils/buttons";
//import { AdServeData } from "../../banner/ad-data";

const Info = () => {
  const banner = useSelector((state) => state.banner);
  const user = useSelector((state) => state.user);
  const template = useSelector((state) => state.template);

  //FOR LATER USE
  //{user && banner.adServeData && (
  //  <Grid.Row>
  //    <Grid.Column computer={16} tablet={16} mobile={16}>
  //      <AdServeData data={banner.adServeData} />
  //    </Grid.Column>
  //  </Grid.Row>
  //)}

  return (
    <>
      <Grid padded className="trade-info">
        <Grid.Row>
          <Grid.Column computer={4} tablet={8} mobile={16}>
            <Header as="h3">Banner info</Header>
            <Segment>
              <List divided celled size="medium">
                <List.Item>
                  <List.Content>
                    <List.Header>Title</List.Header>
                    {banner.bannerTitle}
                  </List.Content>
                </List.Item>
                <List.Item>
                  <List.Content>
                    <List.Header>Ad number</List.Header>
                    {banner.adNumber}
                  </List.Content>
                </List.Item>
                <List.Item>
                  <List.Content>
                    <List.Header>Advertiser</List.Header>
                    {banner.advertiser}
                  </List.Content>
                </List.Item>
                <List.Item>
                  <List.Content>
                    <List.Header>Banner link</List.Header>
                    {banner.url}
                  </List.Content>
                </List.Item>
              </List>
            </Segment>
          </Grid.Column>
          <Grid.Column computer={4} tablet={8} mobile={16}>
            <Header as="h3">Template fields</Header>
            <Segment>
              <List divided celled size="medium">
                {_.map(
                  template.fields,
                  (field, key) =>
                    field.type === "String" && (
                      <List.Item key={key}>
                        <List.Content>
                          <List.Header>{field.name}</List.Header>
                          {banner.fields[field.variable]}
                        </List.Content>
                      </List.Item>
                    )
                )}
              </List>
            </Segment>
          </Grid.Column>
          <Grid.Column computer={4} tablet={8} mobile={16}>
            <Header as="h3">Images</Header>
            <Segment>
              <List divided celled size="medium">
                {_.map(
                  template.fields,
                  (field, key) =>
                    field.type === "File" && (
                      <List.Item key={key}>
                        <List.Content>
                          <List.Header>{field.name}</List.Header>
                          <img
                            src={banner.fields[field.variable]}
                            alt={field.name}
                          />
                        </List.Content>
                      </List.Item>
                    )
                )}
              </List>
            </Segment>
          </Grid.Column>
        </Grid.Row>
      </Grid>
      {user && user.isAdOps && (
        <KevelButtons banner={banner} template={template} />
      )}
    </>
  );
};

export default Info;
